import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    ResponsiveContainer, PieChart, Pie, Sector, Cell, Tooltip
} from 'recharts';
import { setCurrencyFormat, colorsCombination } from '../../../../../utils/helpers';

const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, isOrder,
        payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    const { color, name } = payload

    return (
        <g>
            <text x={cx} y={cy} dy={8} textAnchor="middle" fill={color}>
                {payload.name}
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={color}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={color}
            />
            <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={color} fill="none" />
            <circle cx={ex} cy={ey} r={2} fill={color} stroke="none" />
            <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">
                {`${setCurrencyFormat(Number(value).toFixed(2), !isOrder)}`}</text>
            <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
                {`(${(percent * 100).toFixed(isOrder ? 0 : 2)}%)`}
            </text>
        </g>
    );
};


const DonutChart = ({ totalCounts, channelKeyMap, isOrder, title }) => {
    const [activeIndex, setActiveIndex] = useState(0)


    const onPieEnter = (_, index) => {
        setActiveIndex(index)
    };

    const pieData = [];

    Object.keys(totalCounts || {}).forEach((key, index) => {
        const item = {
            name: channelKeyMap[key],
            value: isOrder ? totalCounts?.[key]?.orderCount : totalCounts?.[key]?.amount,
            color: colorsCombination[index % 10][0] || "#4ce1b6"
        };
        pieData.push(item)
    })

    return (
        <div className="pt-4">
            {title ? <div className="card__title mb-2">
                <h5 className="bold-text">{title}</h5>
            </div> : null}
            <ResponsiveContainer height={250} className="dashboard__area">
                <PieChart width={350} height={400}>
                    <Pie
                        activeIndex={activeIndex}
                        activeShape={props => renderActiveShape({ ...props, isOrder })}
                        data={pieData}
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey="value"
                        onMouseEnter={onPieEnter}
                        formatter={item => setCurrencyFormat(item, false)}
                    >
                        {
                            pieData.map(entry => <Cell fill={entry.color} />)
                        }
                    </Pie>
                </PieChart >
            </ResponsiveContainer >
        </div>
    );
};

DonutChart.propTypes = {
    channelKeyMap: PropTypes.objectOf({}).isRequired,
    totalCounts: PropTypes.objectOf({}).isRequired,
    isOrder: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired
};

export default (DonutChart);
